import { TDefinitionsActions } from './definitions.types'
import * as constants from './definitions.constants'
import { TDefinitions } from 'src/parser/DefinitionsCustomization'

export type TDefinitionsState = Partial<TDefinitions>

export const initialState: TDefinitionsState = {}

export const definitionsReducer = (
  state = initialState,
  action: TDefinitionsActions,
): TDefinitionsState => {
  switch (action.type) {
    case constants.SET_DEFINITIONS:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}

export default definitionsReducer
